import { MutationTree } from "vuex";
import { ThirdPartyAppState } from "./thirdPartyApp.types";

type thirdPartyAppMutationTree = MutationTree<ThirdPartyAppState>;

export const mutations: thirdPartyAppMutationTree = {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setScopes(state, scopes: string[]) {
    state.scopes = scopes;
  }
};
